module.exports = __webpack_public_path__ + "static/media/instagram.a5b3083c.svg";